import script from "./CameraAndMicroPrecheck.vue?vue&type=script&setup=true&lang=js"
export * from "./CameraAndMicroPrecheck.vue?vue&type=script&setup=true&lang=js"

import "./CameraAndMicroPrecheck.vue?vue&type=style&index=0&id=fad157b4&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fad157b4"]])

export default __exports__